export default {
  init() {
    // get all FAQ questions
    // "but you used querySelector everywhere else!" I say, wondering why I didn't use it here
    const faqQuestions = document.getElementsByClassName('faq-question');

    // attach event listener to faq question to toggle its children
    // faqQuestions is an HTMLCollection, no native forEach method
    [].forEach.call(faqQuestions, function(el) {
      el.addEventListener('click', function() {
        // span element with triangle
        const triangle = el.children[0];
        // question answer text
        const answerGraf = el.nextSibling.nextSibling;

        triangle.classList.toggle('rotated');

        answerGraf.classList.toggle('block');
        answerGraf.classList.toggle('hidden');
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/faqs.js